module.exports = __webpack_public_path__ + "static/media/payLaMerced.f4c2cd3b.png";